const translations = {
  en: {
    // Navbar
    dashboard: "Dashboard",
    leaderboard: "Leaderboard",
    results: "Results",
    workshop: "Workshop",
    rules: "Rules",
    standings: "Standings",
    settings: "Settings",
    logout: "Logout",
    
    // Dashboard
    welcome_back: "Welcome back",
    your_team: "Your Team",
    racing_league: "MSF Racing",
    moto_league: "MotoMSF",
    select_team: "Select Team",
    edit_team: "Edit Team",
    no_team_selected: "No team selected yet",
    budget_remaining: "Budget Remaining",
    total_points: "Total Points",
    leaderboard_position: "Leaderboard Position",
    drivers: "Drivers",
    cars: "Cars",
    tuner: "Tuner",
    riders: "Riders",
    bikes: "Bikes",
    team_name: "Team Name",
    
    // Leaderboard
    rank: "Rank",
    player: "Player",
    points: "Points",
    
    // Workshop
    available_boosts: "Available Boosts",
    my_boosts: "My Boosts",
    purchase: "Purchase",
    apply: "Apply",
    sell: "Sell",
    cost: "Cost",
    effect: "Effect",
    
    // Settings
    profile_settings: "Profile Settings",
    display_name: "Display Name",
    profile_picture: "Profile Picture",
    upload_photo: "Upload Photo",
    choose_avatar: "Choose Avatar",
    language: "Language",
    save_changes: "Save Changes",
    account: "Account",
    preferences: "Preferences",
    
    // Results
    race_results: "Race Results",
    championship_standings: "Championship Standings",
    round: "Round",
    download: "Download",
    view: "View",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    
    // Rules
    rules_title: "Game Rules",
    
    // Round status
    round_starts_in: "ROUND {n} STARTS IN {time} — FINALIZE YOUR TEAM & BOOSTS!",
    round_in_progress: "ROUND {n} IN PROGRESS — {time} REMAINING",
    selections_locked: "Selections & boosts locked",
    round_complete: "Round {n} Complete!",
    round_over_msg: "The race is over. Check the standings below.",
    got_it: "Got it!",
  },
  
  ms: {
    dashboard: "Papan Pemuka",
    leaderboard: "Kedudukan",
    results: "Keputusan",
    workshop: "Bengkel",
    rules: "Peraturan",
    standings: "Kedudukan Pusingan",
    settings: "Tetapan",
    logout: "Log Keluar",
    welcome_back: "Selamat kembali",
    your_team: "Pasukan Anda",
    racing_league: "MSF Racing",
    moto_league: "MotoMSF",
    select_team: "Pilih Pasukan",
    edit_team: "Ubah Pasukan",
    no_team_selected: "Belum memilih pasukan",
    budget_remaining: "Baki Bajet",
    total_points: "Jumlah Mata",
    leaderboard_position: "Kedudukan Papan Pemimpin",
    drivers: "Pemandu",
    cars: "Kereta",
    tuner: "Penala",
    riders: "Penunggang",
    bikes: "Motosikal",
    team_name: "Nama Pasukan",
    rank: "Kedudukan",
    player: "Pemain",
    points: "Mata",
    available_boosts: "Rangsangan Tersedia",
    my_boosts: "Rangsangan Saya",
    purchase: "Beli",
    apply: "Guna",
    sell: "Jual",
    cost: "Harga",
    effect: "Kesan",
    profile_settings: "Tetapan Profil",
    display_name: "Nama Paparan",
    profile_picture: "Gambar Profil",
    upload_photo: "Muat Naik Foto",
    choose_avatar: "Pilih Avatar",
    language: "Bahasa",
    save_changes: "Simpan Perubahan",
    account: "Akaun",
    preferences: "Keutamaan",
    race_results: "Keputusan Perlumbaan",
    championship_standings: "Kedudukan Kejuaraan",
    round: "Pusingan",
    download: "Muat Turun",
    view: "Lihat",
    save: "Simpan",
    cancel: "Batal",
    close: "Tutup",
    loading: "Memuatkan...",
    error: "Ralat",
    success: "Berjaya",
    confirm: "Sahkan",
    back: "Kembali",
    next: "Seterusnya",
    rules_title: "Peraturan Permainan",
    round_starts_in: "PUSINGAN {n} BERMULA DALAM {time} — SEDIAKAN PASUKAN ANDA!",
    round_in_progress: "PUSINGAN {n} SEDANG BERLANGSUNG — {time} BERBAKI",
    selections_locked: "Pilihan & rangsangan dikunci",
    round_complete: "Pusingan {n} Selesai!",
    round_over_msg: "Perlumbaan tamat. Semak kedudukan di bawah.",
    got_it: "Faham!",
  },
  
  zh: {
    dashboard: "控制面板",
    leaderboard: "排行榜",
    results: "成绩",
    workshop: "改装车间",
    rules: "规则",
    standings: "赛况",
    settings: "设置",
    logout: "退出登录",
    welcome_back: "欢迎回来",
    your_team: "你的车队",
    racing_league: "MSF Racing",
    moto_league: "MotoMSF",
    select_team: "选择车队",
    edit_team: "编辑车队",
    no_team_selected: "尚未选择车队",
    budget_remaining: "剩余预算",
    total_points: "总积分",
    leaderboard_position: "排行榜位置",
    drivers: "车手",
    cars: "赛车",
    tuner: "改装商",
    riders: "骑手",
    bikes: "摩托车",
    team_name: "车队名称",
    rank: "排名",
    player: "玩家",
    points: "积分",
    available_boosts: "可用加成",
    my_boosts: "我的加成",
    purchase: "购买",
    apply: "使用",
    sell: "出售",
    cost: "价格",
    effect: "效果",
    profile_settings: "个人设置",
    display_name: "显示名称",
    profile_picture: "头像",
    upload_photo: "上传照片",
    choose_avatar: "选择头像",
    language: "语言",
    save_changes: "保存更改",
    account: "账户",
    preferences: "偏好设置",
    race_results: "比赛成绩",
    championship_standings: "锦标赛排名",
    round: "回合",
    download: "下载",
    view: "查看",
    save: "保存",
    cancel: "取消",
    close: "关闭",
    loading: "加载中...",
    error: "错误",
    success: "成功",
    confirm: "确认",
    back: "返回",
    next: "下一步",
    rules_title: "游戏规则",
    round_starts_in: "第{n}回合将在 {time} 后开始 — 完成车队部署！",
    round_in_progress: "第{n}回合进行中 — 剩余 {time}",
    selections_locked: "选择和加成已锁定",
    round_complete: "第{n}回合结束！",
    round_over_msg: "比赛结束。查看下方排名。",
    got_it: "知道了！",
  },
  
  yue: {
    dashboard: "主頁面",
    leaderboard: "排行榜",
    results: "成績",
    workshop: "改裝車間",
    rules: "規則",
    standings: "賽況",
    settings: "設定",
    logout: "登出",
    welcome_back: "歡迎返嚟",
    your_team: "你嘅車隊",
    racing_league: "MSF Racing",
    moto_league: "MotoMSF",
    select_team: "揀車隊",
    edit_team: "改車隊",
    no_team_selected: "未揀車隊",
    budget_remaining: "剩餘預算",
    total_points: "總積分",
    leaderboard_position: "排行榜位置",
    drivers: "車手",
    cars: "賽車",
    tuner: "改裝商",
    riders: "騎手",
    bikes: "電單車",
    team_name: "車隊名",
    rank: "排名",
    player: "玩家",
    points: "積分",
    available_boosts: "可用加成",
    my_boosts: "我嘅加成",
    purchase: "買",
    apply: "用",
    sell: "賣",
    cost: "價錢",
    effect: "效果",
    profile_settings: "個人設定",
    display_name: "顯示名稱",
    profile_picture: "頭像",
    upload_photo: "上傳相片",
    choose_avatar: "揀頭像",
    language: "語言",
    save_changes: "儲存更改",
    account: "賬戶",
    preferences: "偏好設定",
    race_results: "比賽成績",
    championship_standings: "錦標賽排名",
    round: "回合",
    download: "下載",
    view: "睇",
    save: "儲存",
    cancel: "取消",
    close: "閂",
    loading: "載入中...",
    error: "錯誤",
    success: "成功",
    confirm: "確認",
    back: "返回",
    next: "下一步",
    rules_title: "遊戲規則",
    round_starts_in: "第{n}回合將喺 {time} 後開始 — 搞掂你嘅車隊！",
    round_in_progress: "第{n}回合進行中 — 剩餘 {time}",
    selections_locked: "選擇同加成已鎖定",
    round_complete: "第{n}回合完咗！",
    round_over_msg: "比賽完咗。睇下面排名。",
    got_it: "知道喇！",
  },
  
  ta: {
    dashboard: "முகப்பு",
    leaderboard: "தரவரிசை",
    results: "முடிவுகள்",
    workshop: "பட்டறை",
    rules: "விதிகள்",
    standings: "நிலைகள்",
    settings: "அமைப்புகள்",
    logout: "வெளியேறு",
    welcome_back: "மீண்டும் வரவேற்கிறோம்",
    your_team: "உங்கள் அணி",
    racing_league: "MSF Racing",
    moto_league: "MotoMSF",
    select_team: "அணியைத் தேர்வு செய்",
    edit_team: "அணியை மாற்று",
    no_team_selected: "அணி தேர்வு செய்யவில்லை",
    budget_remaining: "மீதமுள்ள பட்ஜெட்",
    total_points: "மொத்த புள்ளிகள்",
    leaderboard_position: "தரவரிசை நிலை",
    drivers: "ஓட்டுநர்கள்",
    cars: "கார்கள்",
    tuner: "ட்யூனர்",
    riders: "சவாரிகள்",
    bikes: "பைக்குகள்",
    team_name: "அணி பெயர்",
    rank: "தரம்",
    player: "வீரர்",
    points: "புள்ளிகள்",
    available_boosts: "கிடைக்கும் பூஸ்ட்கள்",
    my_boosts: "எனது பூஸ்ட்கள்",
    purchase: "வாங்கு",
    apply: "பயன்படுத்து",
    sell: "விற்கவும்",
    cost: "விலை",
    effect: "விளைவு",
    profile_settings: "சுயவிவர அமைப்புகள்",
    display_name: "காட்சி பெயர்",
    profile_picture: "சுயவிவர படம்",
    upload_photo: "படம் பதிவேற்று",
    choose_avatar: "அவதாரத்தைத் தேர்வு செய்",
    language: "மொழி",
    save_changes: "மாற்றங்களைச் சேமி",
    account: "கணக்கு",
    preferences: "விருப்பத்தேர்வுகள்",
    race_results: "பந்தய முடிவுகள்",
    championship_standings: "சாம்பியன்ஷிப் நிலை",
    round: "சுற்று",
    download: "பதிவிறக்கம்",
    view: "பார்",
    save: "சேமி",
    cancel: "ரத்து",
    close: "மூடு",
    loading: "ஏற்றுகிறது...",
    error: "பிழை",
    success: "வெற்றி",
    confirm: "உறுதிசெய்",
    back: "பின்",
    next: "அடுத்து",
    rules_title: "விளையாட்டு விதிகள்",
    round_starts_in: "சுற்று {n} {time} இல் தொடங்கும் — உங்கள் அணியை தயார் செய்யுங்கள்!",
    round_in_progress: "சுற்று {n} நடைபெறுகிறது — {time} மீதமுள்ளது",
    selections_locked: "தேர்வுகள் & பூஸ்ட்கள் பூட்டப்பட்டுள்ளன",
    round_complete: "சுற்று {n} முடிந்தது!",
    round_over_msg: "பந்தயம் முடிந்தது. கீழே உள்ள நிலைகளைப் பாருங்கள்.",
    got_it: "புரிந்தது!",
  },
};

export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "ms", label: "Bahasa Melayu", nativeLabel: "Bahasa Melayu" },
  { code: "zh", label: "Mandarin", nativeLabel: "中文" },
  { code: "yue", label: "Cantonese", nativeLabel: "廣東話" },
  { code: "ta", label: "Tamil", nativeLabel: "தமிழ்" },
];

export default translations;
